import React from "react";
import { ChevronDown } from "lucide-react";

function BookingTypeSelector({ type, onTypeChange, selfDriveCondition, t, error, touched }) {
  const handleChange = (e) => {
    onTypeChange(e.target.value);
  };

  const getBookingOptions = () => {
    if (selfDriveCondition === "without_driver") {
      return [{ value: "self_drive", label: t("self_drive") || "Self Drive" }];
    }

    return [
      { value: "tour", label: t("tour") || "Tour" },
      { value: "transfer_service", label: t("transfer_service") || "Transfer Service" },
    ];
  };

  return (
    <div className="relative">
      <label className="block mb-2 text-sm font-medium text-slate-400">{t("booking_type") || "Booking Type"}</label>
      <select
        value={type}
        onChange={handleChange}
        className="w-full bg-white text-slate-700 text-base md:text-lg rounded-sm px-5 py-4 pr-12 appearance-none focus:outline-none focus:ring-2 focus:ring-[#f5272b] transition-all"
      >
        <option value="" disabled>
          {t("select_booking_type") || "Select Booking Type"}
        </option>
        {getBookingOptions().map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown
        className="absolute -translate-y-1/2 pointer-events-none right-4 top-[67%] text-slate-400"
        size={24}
      />
      {touched && error ? <p className="mt-1 text-sm text-red-400 error-modal">{error}</p> : null}
    </div>
  );
}

export default BookingTypeSelector;
